<div class="card kpi-red">
    <div class="card-body kpi-card">
        <h5 class="card-title">Total des charges <i class="fa fa-question-circle" matTooltipClass="tooltip-button" matTooltip="Correspond à la somme de la mensualité de crédit et des charges"></i></h5>
        <p class="card-value">
            <ng-container *ngIf="preview">- €</ng-container>
            <ng-container *ngIf="!preview">
                {{ favorite.charge + favorite.monthly | number: '1.0-0' }} €
            </ng-container>
        </p>
    </div>
</div>
